<template lang="pug">
    .z-markdown(v-bind:class="{'focus': focus, 'has-value': value && value.length, 'has-error': error && error.length, 'disabled': $props.disabled, 'readonly': $props.readonly}")
        .z-markdown-container
            label(v-if="$props.label" v-bind:for="$props.id") {{$props.label + (($props.required) ? ' *' : '') + ($props.readonly ? ' (только для чтения)' : '') + ($props.loading ? ' (загрузка)' : '') }}
            
            .preview(v-show="!editMode" v-html="previewText" v-on:click="edit")

            textarea.edit-area(
                ref="editarea"
                v-show="editMode"
                v-model="val"
                v-on:focus="onFocus"
                v-on:blur="onBlur"
                v-on:keyup="onKeyUp"
                v-on:keypress="onKeyPress"
            )

        span.z-error(v-if="error") {{error}}
</template>
<script>
    import marked from 'marked';
    export default {
        name: 'z-markdown',
        components: {},
        props: {
            type: {
                type: String,
                default: 'text'
            },
            id: {
                type: String,
                default: 'z-input'
            },
            name: {
                type: String,
                default: 'z-input'
            },
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            autocomplete: {
                type: String,
                default: 'On'
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                type: [String, Number],
                default: () => ''
            },
            mask: {
                type: String,
                default: undefined
            },
            minlength: {
                type: Number,
                default: 0
            },
            maxlength: {
                type: Number,
                default: 256
            }
        },
        data() {
            return {
                focus: false,
                editMode: false,
                val: ''
            }
        },
        created() {
            if (this.$props.value) this.val = this.$props.value;
        },
        watch: {
            'value'(value) {
                if (this.val != value) this.val = value;
            },
            'val'(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            }
        },
        computed: {
            previewText() {
                marked.setOptions({
                    renderer: new marked.Renderer(),
                    gfm: true,
                    tables: true,
                    breaks: true,
                    pedantic: false,
                    sanitize: true,
                    smartLists: true,
                    smartypants: false
                });
                
                return (this.val) ? marked(this.val) : '';
            }
        },
        methods: {
            edit() {
                this.editMode = true;
                this.$nextTick(() => {
                    this.$refs.editarea.focus();
                });
            },
            onFocus(e) {
                this.focus = true;
                this.editMode = true;
                this.$emit('focus', e);
            },
            onBlur(e) {
                this.focus = false;
                this.editMode = false;
                this.$emit('blur', e);
            },
            onKeyUp(e) {
                this.$emit('keyup', e);
            },
            onKeyPress(e) {
                this.$emit('keypress', e);
            }
        }
    }
</script>
<style lang="sass">
    .z-markdown
        margin: 4px 0 10px 0
        .z-markdown-container
            padding: 16px 0 0 0
            position: relative
            &::before
                content: ''
                position: absolute
                bottom: 0
                right: 0
                left: 0
                z-index: 1
                height: 2px
                opacity: 0
                transform: scaleX(.12)
                background-color: #2196f3
                transition: .3s cubic-bezier(.4,0,.2,1)
            &::after
                content: ''
                position: absolute
                bottom: 0
                right: 0
                left: 0
                z-index: 1
                transition: border .3s cubic-bezier(.4,0,.2,1),opacity .3s cubic-bezier(.4,0,.2,1),-webkit-transform 0s cubic-bezier(.4,0,.2,1) .3s
                will-change: border,opacity,transform
                background-color: rgba(0, 0, 0, 0.42)
                height: 1px
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 12px
            line-height: 12px
            padding-top: 2px
            color: #ff1744
        label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 16px
            line-height: 14px
            position: absolute
            left: 0px
            top: 25px
            transition: .4s cubic-bezier(.25,.8,.25,1)
            transition-duration: .3s
            z-index: 5
        .preview
            font-size: 16px
            border: none
            background: transparent
            outline: none
            color: #000
            font-weight: 400
            min-height: 32px
            width: 100%
            position: relative
            z-index: 10
        .edit-area
            font-size: 16px
            border: none
            background: transparent
            outline: none
            color: #000
            font-weight: 400
            height: 32px
            width: 100%
            position: relative
            z-index: 10
            resize: none
            height: 200px
            background: #ebebeb
            padding: 6px
        .error
    .z-markdown.has-error
        label   
            color: #ff1744
        .z-markdown-container
            &::after
                background-color: #ff1744
            &::before
                background-color: #ff1744
    .z-markdown.focus
        label
            top: 0
            color:  #2196f3
            font-size: 12px
        .z-markdown-container
            &::after
                background-color: #2196f3
            &::before
                opacity: 1
                transform: scaleX(1)
                transition-property: border,opacity,transform,-webkit-transform
                background-color: #2196f3
    .z-markdown.has-value
        label
            top: 0
            font-size: 12px
    .z-markdown.disabled
        input
            background: #eaeaea
    .z-markdown.readonly
        input
            background: #eaeaea
</style>


// WEBPACK FOOTER //
// ZMarkdown.vue?2161caa8